module.exports = __webpack_public_path__ + "static/media/hack_2_bg.fce82f7f.jpg";